export default __webpack_public_path__ + "static/media/PrintsImage03.25c88d34.jpg";